import { tbl_usuario } from '../../db-schema';
import { SerializedDates } from '../../utils/type';

export const GENDER_VALUES = ['Masculino', 'Femenino'] as const;
export const PROFESSION_VALUES = [
  'Administración',
  'Arquitectura',
  'Biología',
  'Contabilidad',
  'Derecho',
  'Economía',
  'Física',
  'Gestión Ambiental',
  'Ingeniería Agroindustrial',
  'Ingeniería Agrónoma',
  'Ingeniería Ambiental',
  'Ingeniería Civil',
  'Ingeniería de Minas',
  'Ingeniería de Petróleo y Gas Natural',
  'Ingeniería de Seguridad y Salud en el Trabajo (SST)',
  'Ingeniería de Sistemas / Tecnologías de Información',
  'Ingeniería Eléctrica',
  'Ingeniería Electrónica',
  'Ingeniería Empresarial',
  'Ingeniería Forestal',
  'Ingeniería Geológica',
  'Ingeniería Industrial',
  'Ingeniería Mecánica',
  'Ingeniería Mecánica Eléctrica',
  'Ingeniería Metalúrgica',
  'Ingeniería Química',
  'Ingeniería Sanitaria',
  'Química',
  'Seguridad Industrial / SSOMA',
  'Técnico Ambiental',
  'Técnico de Laboratorio',
  'Técnico Electricista',
  'Técnico Electrónico',
  'Técnico en Construcción Civil',
  'Técnico en Seguridad y Salud en el Trabajo',
  'Técnico Industrial',
  'Técnico Mecánico',
  'Técnico Minero',
  'Otro',
] as const;

export const ACADEMIC_DEGREE_VALUES = [
  'Bachiller',
  'Doctor(a) / PhD',
  'Egresado(a)',
  'Estudiante',
  'Magíster',
  'Tecnico(a)',
  'Titulado(a) / Colegiado(a)',
  'Otro',
] as const;

export const LABOR_SECTOR_VALUES = [
  'Actualmente no trabajo',
  'Agricultura / Agroindustria',
  'Construcción e Infraestructura',
  'Independiente / Consultor',
  'Minería',
  'Otro',
] as const;
export const ACQUISITION_SOURCE_VALUES = [
  'Facebook',
  'Instagram',
  'LinkedIn',
  'TikTok',
  'Buscador web',
  'Recomendación',
] as const;
export const REGISTER_TYPE_VALUES = ['Normal', 'Google'] as const;

export type Gender = (typeof GENDER_VALUES)[number];
export type Profession = (typeof PROFESSION_VALUES)[number];
export type AcademicDegree = (typeof ACADEMIC_DEGREE_VALUES)[number];
export type ProfessionalLine = string;
export type LaborSector = (typeof LABOR_SECTOR_VALUES)[number];
export type AcquisitionSource = (typeof ACQUISITION_SOURCE_VALUES)[number];
export type RegisterType = (typeof REGISTER_TYPE_VALUES)[number];

export interface UserEntity extends SerializedDates<tbl_usuario> {
  usuario_genero: Gender | null;
  usuario_grado_academico: AcademicDegree | null;
  usuario_tipo: RegisterType;
}

export type User = Pick<
  UserEntity,
  | 'usuario_id'
  | 'usuario_nombres'
  | 'usuario_apellidos'
  | 'usuario_fecha_nacimiento'
  | 'usuario_correo'
  | 'usuario_telefono'
  | 'usuario_imagen'
  | 'usuario_pais'
  | 'usuario_pais_origen'
  | 'usuario_carnet_identidad'
  | 'usuario_profesion'
  | 'usuario_linea_profesional'
  | 'usuario_sector_laboral'
  | 'usuario_origen_captacion'
  | 'usuario_departamento'
  | 'usuario_genero'
  | 'usuario_grado_academico'
  | 'usuario_perfil_profesional_fecha_completado'
  | 'usuario_perfil_demografico_fecha_completado'
  | 'usuario_perfil_profesional_fecha_pospuesto'
  | 'usuario_perfil_profesional_veces_pospuesto'
  | 'usuario_perfil_demografico_fecha_pospuesto'
  | 'usuario_perfil_demografico_veces_pospuesto'
  | 'usuario_estado_nombre'
  | 'usuario_tipo'
  | 'usuario_estado_carnet_identidad'
  | 'usuario_descripcion'
> & {
  kommo_user_id: string;
  usuario_perfil_profesional_pendiente: boolean;
  usuario_perfil_demografico_pendiente: boolean;
};
